import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  IconButton,
  useTheme
} from '@mui/material';
import {
  ArrowBack as ArrowBackIcon
} from '@mui/icons-material';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { proposalsAPI } from '../../services/api';
import LoadingSpinner from '../LoadingSpinner';
import ProposalForm from './ProposalForm';

const ProposalEditPage = () => {
  const theme = useTheme();
  const { id } = useParams();
  const navigate = useNavigate();
  const [proposal, setProposal] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProposal();
  }, [id]);

  const fetchProposal = async () => {
    try {
      setLoading(true);
      const response = await proposalsAPI.getById(id);
      setProposal(response.data.proposal);
    } catch (error) {
      console.error('Error fetching proposal:', error);
      toast.error('Failed to fetch proposal details');
      navigate('/proposals');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (data) => {
    try {
      await proposalsAPI.update(id, data);
      toast.success('Proposal updated successfully');
      navigate('/proposals');
    } catch (error) {
      console.error('Error updating proposal:', error);
      toast.error('Failed to update proposal');
    }
  };

  const handleCancel = () => {
    navigate('/proposals');
  };

  if (loading) {
    return <LoadingSpinner message="Loading proposal details..." />;
  }

  if (!proposal) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="h6" color="text.secondary">
          Proposal not found
        </Typography>
        <Button
          variant="contained"
          onClick={() => navigate('/proposals')}
          sx={{ mt: 2 }}
        >
          Back to Proposals
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ pl: 3 }}>
      {/* Header */}
      <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
        <IconButton
          onClick={() => navigate('/proposals')}
          sx={{
            backgroundColor: theme.palette.background.paper,
            '&:hover': {
              backgroundColor: theme.palette.action.hover
            }
          }}
        >
          <ArrowBackIcon />
        </IconButton>
        <Box>
          <Typography variant="h4" fontWeight={700}>
            Edit Proposal
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {proposal.title}
          </Typography>
        </Box>
      </Box>

      {/* Form */}
      <ProposalForm
        proposal={proposal}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </Box>
  );
};

export default ProposalEditPage;